export default "/static/baf88e224766ff3ef06b01b071d6a976593a2da1/frontend/1c2dc0f32895d26aac4476663547b9b3.svg";